import { useId } from "react";
import Link from "next/link";

import { cn } from "@/lib/utils";
import type { RelatedRentals } from "./types";

/**
 * 랜딩 하단 "함께 찾는 렌탈"(B3) — 목록 맨 끝, 푸터 바로 위의 푸터 톤 링크 묶음.
 * 본문처럼 보이지 않게 회색 바탕·작은 글씨, 요약·질문 없이 링크(≤ 6)만 둔다.
 * 링크는 서버가 색인 랜딩 정규 URL 로만 만든다(lib/seo/landing-links). 크롤 대상이라
 * 사용자가 실제로 누를 일은 적으므로 미리 받지 않는다(prefetch={false}).
 *
 * `className` 은 놓이는 자리의 여백 — 모바일 드로어는 `px-4`, 패딩 있는 목록 열은 회색 띠가
 * 열 끝까지 닿도록 `-mx-6 px-6`.
 */
export function RelatedRentalsNav({
  data,
  className,
}: {
  data: RelatedRentals;
  className?: string;
}) {
  const headingId = useId();
  if (data.links.length === 0) return null;
  return (
    <nav aria-labelledby={headingId} className={cn("mt-4 bg-gray-50 pt-5 pb-2 sm:pt-6", className)}>
      <h2 id={headingId} className="mb-2.5 text-[13px] font-semibold text-gray-700">
        {data.title}
      </h2>
      <ul className="grid grid-cols-2 gap-x-4 gap-y-2 sm:grid-cols-3">
        {data.links.map((link) => (
          <li key={link.href} className="min-w-0">
            <Link
              href={link.href}
              prefetch={false}
              className="text-[13px] text-gray-600 break-keep wrap-anywhere hover:text-gray-900 hover:underline"
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
